/**
 * Registers custom SurveyJS locales not supported out of the box (currently just Haitian
 * Creole)
 */
import * as SurveyJS from "survey-vue";
import ht from "./ht.json";

export function registerLocale(surveyLocalization, code, localeData) {
  surveyLocalization.locales[code] = localeData.strings;
  surveyLocalization.localeNames[code] = localeData.localeName;
}

registerLocale(SurveyJS.surveyLocalization, "ht", ht);
